import { useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { rightPanelHeaderAtom } from '@/atoms/sidebar';

export const useRightPanelHeader = (title: string | undefined, onClose: () => void) => {
  const setHeader = useSetAtom(rightPanelHeaderAtom);

  useEffect(() => {
    setHeader({ title, onClose });
  }, [onClose, title, setHeader]);

  useEffect(
    () => () => {
      setHeader(null);
    },
    [setHeader],
  );
};
